export const translations = {
  en: {
    nav: {
      how: "How it Works",
      pricing: "Pricing",
      why: "Why Us",
      contact: "Contact",
      cta: "Create Profile",
    },
    hero: {
      eyebrow: "Miami → Costa Rica · Air Express",
      title1: "Trusted & Reliable",
      title2: "Shipping Service to your door",
      title3: "anywhere in Costa Rica!",
      subtitle: "Shop your favorite U.S. retailers — Amazon, eBay, SHEIN, Walmart — and we fly your boxes from our Miami warehouse straight to you.",
      cta: "Create Your Profile!",
      ctaBadge: "Get Started",
      ctaTitle: "Create your Ship Costa Rica Profile today.",
      ctaSub: "Set up and start shipping with us TODAY!",
      ctaFootnote: "Free signup · Cancel anytime · Nationwide reach in CR",
      secondary: "See pricing",
      stat1: "Air shipping",
      stat1v: "$15 / kilo",
      stat2: "Delivery time",
      stat2v: "5–7 days",
      stat3: "Support",
      stat3v: "24/7",
    },
    marquee: "Amazon · eBay · SHEIN · Walmart · Best Buy · Target · Nike · Apple · Sephora",
    why: {
      eyebrow: "Why Ship Costa Rica",
      title: "The fastest, most trusted way to bring U.S. shopping home.",
      cards: [
        { t: "Nationwide reach across Costa Rica", d: "We hand off to local courier in San José for last-mile delivery anywhere in the country — San José, Heredia, Alajuela, Cartago, Liberia, Tamarindo, Playa Jacó, Quepos, Manuel Antonio, Nosara, Limón, Puntarenas, Santa Cruz, Guanacaste. Last-mile fee is paid directly to the courier (3 options)." },
        { t: "Air shipping in 5–7 days", d: "From the moment your box arrives at our Miami warehouse, you'll have it at home in under a week." },
        { t: "Tracked from Miami onward", d: "Real-time package status from arrival in Miami all the way to your doorstep — nothing gets lost." },
        { t: "Safe & secure handling", d: "Insured handling, careful packing checks, and a logistics team that treats your boxes like their own." },
        { t: "24/7 customer service", d: "Real humans, day or night. Email, WhatsApp, or message — we're always here to help." },
        { t: "Shop any U.S. retailer", d: "Amazon, eBay, SHEIN, Walmart, Best Buy — if it ships to Miami, we ship it to you." },
      ],
    },
    pricing: {
      eyebrow: "Simple, honest pricing",
      title: "Air Shipping",
      price: "$15",
      perKilo: "per kilo",
      tag: "Air freight Miami → San José, Costa Rica",
      includes: [
        "Free Miami warehouse address",
        "Air freight Miami → San José, CR",
        "Customs handling included",
        "Hand-off to local courier in San José",
        "Real-time tracking from Miami",
        "24/7 customer support",
      ],
      footnote: "Last-mile from our San José warehouse to your door is an extra fee based on weight & size, paid directly to the courier (3 delivery options available).",
      cta: "Start shipping today",
    },
    how: {
      eyebrow: "How it works",
      title: "Three simple steps to your front door.",
      sub: "Sign up, share your tracking, and we deliver. That's it.",
      stepLabel: "Step",
      steps: [
        { t: "Create your ShipCR profile", d: "Sign up in 2 minutes and create your personal ShipCR profile and tracking link!" },
        { t: "Upload your tracking numbers", d: "Shop anywhere online and add your tracking numbers to your personal ShipCR Profile, track the status from Miami Warehouse upon arrival to your doorstep!" },
        { t: "Pay easily and receive at your door", d: "Once your package is received in the San Jose Warehouse, we will send invoice for payment and arrange your packages to be sent directly to your home or work!" },
      ],
      cta: "Create your Profile",
      footnote: "Takes 2 minutes · No credit card required",
    },
    testimonials: {
      eyebrow: "From our customers",
      title: "Loved by shoppers across Costa Rica.",
      lead: "Start Ordering & Shipping Today! Our team of professionals are excited to help you order from all of your favorite stores like Amazon, eBay, SHEIN, or any major retailer. Contact us & we can help you get started with our shipping service.",
      items: [
        { q: "Boxes from Amazon arrived in 6 days, perfectly packed. The team kept me updated the whole way.", n: "Andrea M.", c: "San José" },
        { q: "Finally a service that actually delivers to my door in Guanacaste. The price is unbeatable.", n: "Carlos R.", c: "Tamarindo" },
        { q: "I order from SHEIN every month and Ship Costa Rica makes it effortless. Fast, safe, friendly.", n: "Mariana V.", c: "Heredia" },
      ],
    },
    contact: {
      eyebrow: "Talk to us",
      title: "Ready to start? We're online 24/7.",
      sub: "Send us a message, email Greg directly, or jump straight into creating your profile.",
      name: "Name",
      email: "Email",
      emailUs: "Email us",
      phone: "Phone (optional)",
      message: "Message (optional)",
      send: "Send message",
      sending: "Sending...",
      thankYou: "Message sent!",
      thankYouSub: "We'll get back to you within 24 hours, often much faster.",
      sendAnother: "Send another message",
      error: "Something went wrong. Please email Greg@ShipCR.com directly.",
      fbLabel: "Message on Facebook",
      facebook: "Message on Facebook",
      cta: "Create your Profile",
      ctaSub: "Free · 2 minutes",
    },
    tracking: {
      eyebrow: "Track your package",
      title: "Where's my package right now?",
      sub: "Enter your tracking number to see live status from our Miami warehouse all the way to your door.",
      placeholder: "Tracking number (e.g. 1Z999AA10123456784)",
      emailPlaceholder: "Email (optional, for updates)",
      cta: "Check status",
      checking: "Checking...",
      error: "We couldn't find that tracking number. Email Greg@ShipCR.com and we'll look it up for you.",
    },
    calc: {
      eyebrow: "Cost calculator",
      title: "How much will my shipment cost?",
      sub: "Drag the slider or type your weight in kilos. Air freight Miami → San José is flat $15/kg — last-mile to your door is paid separately to the courier (see below).",
      label: "Total weight",
      kgs: "kilos",
      lbs: "pounds",
      unitToggleLabel: "Weight unit",
      unitKg: "Per kg · $15",
      unitLb: "Per lb · $6.80",
      rate: "Air freight rate",
      totalEyebrow: "Your air freight estimate",
      allInclusive: "Miami → San José, Costa Rica",
      transit: "Transit time",
      delivery: "Last-mile delivery",
      doorToDoor: "Extra fee*",
      support: "Support",
      cta: "Start shipping at this rate",
      lastMileNote: "*Last-mile from our San José, CR warehouse to your door is an extra cost based on weight & size — we offer 3 delivery options, paid directly to the courier.",
    },
    cities: {
      eyebrow: "Cities we ship to",
      title: "Door-to-door delivery across Costa Rica.",
      sub: "Click any city to see local shipping details, transit times and a custom quote.",
    },
    relocation: {
      eyebrow: "Relocation services",
      title: "Moving to Costa Rica?",
      body: "We can help arrange moving from anywhere in the USA — relocating you to anywhere in Costa Rica! Contact us for more info.",
      cta: "WhatsApp us",
    },
    whatsapp: {
      online: "Online · 24/7",
      chatPrompt: "Chat with us on WhatsApp",
      aria: "Chat with Ship Costa Rica on WhatsApp",
    },
    footer: {
      tagline: "Air shipping from Miami to your door in Costa Rica.",
      rights: "All rights reserved.",
      links: { how: "How it works", pricing: "Pricing", why: "Why us", contact: "Contact" },
    },
  },
  es: {
    nav: {
      how: "Cómo funciona",
      pricing: "Precios",
      why: "Por qué",
      contact: "Contacto",
      cta: "Crear perfil",
    },
    hero: {
      eyebrow: "Miami → Costa Rica · Aéreo Exprés",
      title1: "Servicio de envíos",
      title2: "confiable y seguro a tu puerta",
      title3: "en cualquier lugar de ¡Costa Rica!",
      subtitle: "Compra en tus tiendas favoritas de EE.UU. — Amazon, eBay, SHEIN, Walmart — y volamos tus cajas desde nuestra bodega en Miami directamente a ti.",
      cta: "¡Crea tu perfil!",
      ctaBadge: "Comenzar",
      ctaTitle: "Crea tu perfil de Ship Costa Rica hoy.",
      ctaSub: "¡Regístrate y empieza a enviar con nosotros HOY!",
      ctaFootnote: "Registro gratis · Cancela cuando quieras · Cobertura nacional en CR",
      secondary: "Ver precios",
      stat1: "Envío aéreo",
      stat1v: "$15 / kilo",
      stat2: "Tiempo de entrega",
      stat2v: "5–7 días",
      stat3: "Soporte",
      stat3v: "24/7",
    },
    marquee: "Amazon · eBay · SHEIN · Walmart · Best Buy · Target · Nike · Apple · Sephora",
    why: {
      eyebrow: "Por qué Ship Costa Rica",
      title: "La forma más rápida y confiable de traer tus compras de EE.UU.",
      cards: [
        { t: "Cobertura nacional en toda Costa Rica", d: "Entregamos al courier local en San José para la última milla a cualquier parte del país — San José, Heredia, Alajuela, Cartago, Liberia, Tamarindo, Playa Jacó, Quepos, Manuel Antonio, Nosara, Limón, Puntarenas, Santa Cruz, Guanacaste. La última milla se paga directamente al courier (3 opciones)." },
        { t: "Envío aéreo en 5 a 7 días", d: "Desde que tu caja llega a nuestra bodega de Miami, la tendrás en casa en menos de una semana." },
        { t: "Seguimiento desde Miami", d: "Estatus en tiempo real desde la llegada a Miami hasta tu puerta — ningún paquete se pierde." },
        { t: "Manejo seguro y protegido", d: "Manejo asegurado, revisiones cuidadosas y un equipo logístico que cuida tus cajas como propias." },
        { t: "Servicio al cliente 24/7", d: "Personas reales, de día o de noche. Email, WhatsApp o mensaje — siempre estamos para ayudar." },
        { t: "Compra en cualquier tienda de EE.UU.", d: "Amazon, eBay, SHEIN, Walmart, Best Buy — si llega a Miami, te lo enviamos." },
      ],
    },
    pricing: {
      eyebrow: "Precio simple y honesto",
      title: "Envío Aéreo",
      price: "$15",
      perKilo: "por kilo",
      tag: "Carga aérea Miami → San José, Costa Rica",
      includes: [
        "Dirección gratuita en Miami",
        "Carga aérea Miami → San José, CR",
        "Trámites aduanales incluidos",
        "Entrega al courier local en San José",
        "Seguimiento en tiempo real desde Miami",
        "Atención al cliente 24/7",
      ],
      footnote: "El último tramo desde nuestra bodega en San José hasta tu puerta tiene un costo adicional según peso y tamaño, pagado directamente al courier (3 opciones de entrega).",
      cta: "Empieza a enviar hoy",
    },
    how: {
      eyebrow: "Cómo funciona",
      title: "Tres pasos simples hasta tu puerta.",
      sub: "Regístrate, comparte tu tracking y nosotros entregamos. Así de fácil.",
      stepLabel: "Paso",
      steps: [
        { t: "Crea tu perfil de ShipCR", d: "¡Regístrate en 2 minutos y crea tu perfil personal de ShipCR con tu enlace de tracking!" },
        { t: "Sube tus números de tracking", d: "¡Compra en cualquier tienda en línea y agrega tus tracking a tu perfil personal de ShipCR para seguir el estado desde la bodega de Miami hasta tu puerta!" },
        { t: "Paga fácil y recibe en tu puerta", d: "¡Cuando tu paquete llegue a nuestra bodega en San José, te enviamos la factura y coordinamos la entrega directamente a tu casa u oficina!" },
      ],
      cta: "Crear mi perfil",
      footnote: "Toma 2 minutos · Sin tarjeta de crédito",
    },
    testimonials: {
      eyebrow: "De nuestros clientes",
      title: "Amados por compradores en toda Costa Rica.",
      lead: "¡Empieza a ordenar y enviar hoy! Nuestro equipo de profesionales está listo para ayudarte a ordenar de tus tiendas favoritas como Amazon, eBay, SHEIN o cualquier tienda mayor. Contáctanos y te ayudamos a empezar.",
      items: [
        { q: "Mis cajas de Amazon llegaron en 6 días, perfectamente empacadas. El equipo me mantuvo informada todo el tiempo.", n: "Andrea M.", c: "San José" },
        { q: "Por fin un servicio que sí me entrega en mi puerta en Guanacaste. El precio es inmejorable.", n: "Carlos R.", c: "Tamarindo" },
        { q: "Ordeno de SHEIN cada mes y Ship Costa Rica lo hace sencillo. Rápido, seguro y atento.", n: "Mariana V.", c: "Heredia" },
      ],
    },
    contact: {
      eyebrow: "Hablemos",
      title: "¿Listo para empezar? Estamos en línea 24/7.",
      sub: "Mándanos un mensaje, escríbele a Greg directamente o crea tu perfil ahora.",
      name: "Nombre",
      email: "Correo",
      emailUs: "Escríbenos",
      phone: "Teléfono (opcional)",
      message: "Mensaje (opcional)",
      send: "Enviar mensaje",
      sending: "Enviando...",
      thankYou: "¡Mensaje enviado!",
      thankYouSub: "Te respondemos en menos de 24 horas, casi siempre mucho antes.",
      sendAnother: "Enviar otro mensaje",
      error: "Algo salió mal. Escríbele directamente a Greg@ShipCR.com.",
      fbLabel: "Mensaje en Facebook",
      facebook: "Mensaje en Facebook",
      cta: "Crear mi perfil",
      ctaSub: "Gratis · 2 minutos",
    },
    tracking: {
      eyebrow: "Rastrea tu paquete",
      title: "¿Dónde está mi paquete ahora?",
      sub: "Ingresa tu número de tracking y mira el estado en vivo desde nuestra bodega en Miami hasta tu puerta.",
      placeholder: "Número de tracking (ej. 1Z999AA10123456784)",
      emailPlaceholder: "Correo (opcional, para actualizaciones)",
      cta: "Consultar estado",
      checking: "Consultando...",
      error: "No encontramos ese tracking. Escríbele a Greg@ShipCR.com y lo buscamos por ti.",
    },
    calc: {
      eyebrow: "Calculadora de precio",
      title: "¿Cuánto costará mi envío?",
      sub: "Mueve el slider o escribe el peso en kilos. Carga aérea Miami → San José a $15/kg — la última milla a tu puerta se paga aparte al courier (ver abajo).",
      label: "Peso total",
      kgs: "kilos",
      lbs: "libras",
      unitToggleLabel: "Unidad de peso",
      unitKg: "Por kg · $15",
      unitLb: "Por lb · $6.80",
      rate: "Tarifa aérea",
      totalEyebrow: "Tu estimado de carga aérea",
      allInclusive: "Miami → San José, Costa Rica",
      transit: "Tiempo de tránsito",
      delivery: "Última milla",
      doorToDoor: "Costo extra*",
      support: "Soporte",
      cta: "Empezar a enviar a esta tarifa",
      lastMileNote: "*El último tramo desde nuestra bodega en San José, CR hasta tu puerta tiene un costo adicional según peso y tamaño — ofrecemos 3 opciones de entrega, pagadas directamente al courier.",
    },
    cities: {
      eyebrow: "Ciudades que servimos",
      title: "Entrega puerta a puerta en toda Costa Rica.",
      sub: "Haz clic en cualquier ciudad para ver detalles, tiempos de entrega y cotización.",
    },
    relocation: {
      eyebrow: "Servicio de mudanza",
      title: "¿Te mudas a Costa Rica?",
      body: "¡Te ayudamos con tu mudanza desde cualquier lugar de EE.UU. hasta cualquier punto de Costa Rica! Escríbenos para más info.",
      cta: "Escríbenos por WhatsApp",
    },
    whatsapp: {
      online: "En línea · 24/7",
      chatPrompt: "Chatea con nosotros por WhatsApp",
      aria: "Chatea con Ship Costa Rica por WhatsApp",
    },
    footer: {
      tagline: "Envío aéreo desde Miami hasta tu puerta en Costa Rica.",
      rights: "Todos los derechos reservados.",
      links: { how: "Cómo funciona", pricing: "Precios", why: "Por qué", contact: "Contacto" },
    },
  },
};
